import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { NGXLogger } from 'ngx-logger';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

interface ImageItem {
  itemImageSrc: string;
  alt: string;
  title: string;
}

@Component({
  selector: 'app-carosello-immagini',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    CarouselModule,
    LottieComponent
  ],
  templateUrl: './carosello-immagini.component.html',
  styleUrls: ['./carosello-immagini.component.scss']
})
export class CaroselloImmaginiComponent implements OnInit, OnChanges {
  private _visible: boolean = false;
  private _codiceScheda: string = '';

  @Input()
  set visible(value: boolean) {
    this._visible = value;
    if (value && this._codiceScheda) {
      this.caricaImmagini();
    }
  }
  get visible(): boolean {
    return this._visible;
  }

  @Input()
  set codiceScheda(value: string) {
    this._codiceScheda = value;
    if (this._visible && value) {
      this.caricaImmagini();
    }
  }
  get codiceScheda(): string {
    return this._codiceScheda;
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() isEnteEsecutore: boolean = false;

  images: ImageItem[] = [];
  activeIndex: number = 0;
  loading: boolean = false;

  options: AnimationOptions = {
    path: '/assets/animations/loader-immagini.json',
    loop: true,
    autoplay: true
  };

  noImagesOptions: AnimationOptions = {
    path: '/assets/animations/no-images.json',
    loop: true,
    autoplay: true
  };

  constructor(
    private firebaseStorageService: FirebaseStorageService,
    private logger: NGXLogger
  ) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible'] || changes['codiceScheda']) {
      this.logger.info(`[CAROSELLO] Changes in visible or codiceScheda - visible: ${this._visible}, codiceScheda: ${this._codiceScheda}`);
    }
  }

  async caricaImmagini() {
    if (!this._codiceScheda) {
      return;
    }

    this.loading = true;

    try {
      const path = `schede/${this._codiceScheda}/immagini`;
      this.logger.info(`[CAROSELLO] Richiesta immagini dal percorso: ${path}`);

      const urls = await this.firebaseStorageService.listFilesPromise(path);
      this.logger.info(`[CAROSELLO] Ricevute ${urls.length} immagini`);

      this.images = urls.map(url => ({
        itemImageSrc: url,
        alt: `Immagine scheda ${this._codiceScheda}`,
        title: `Scheda ${this._codiceScheda}`
      }));

      if (urls.length === 0) {
        this.logger.warn(`[CAROSELLO] Nessuna immagine trovata per la scheda ${this._codiceScheda}`);
      }
    } catch (error) {
      this.logger.error('[CAROSELLO] Errore nel caricamento delle immagini:', error);
    } finally {
      this.loading = false;
    }
  }

  onHide() {
    this.logger.info('[CAROSELLO] Chiusura modale');
    this._visible = false;
    this.visibleChange.emit(false);
  }

  onButtonHover(event: any, isHover: boolean) {
    const button = event.target.closest('p-button');
    if (button) {
      if (isHover) {
        button.style.transform = 'translateY(-2px)';
        button.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
      } else {
        button.style.transform = 'translateY(0)';
        button.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      }
    }
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.onHide();
    } else {
      // TODO: Implementare il download di tutte le immagini
    }
  }
}
